import { getErrorCode, parseErrorMessage } from 'src/services/repository/utils-repository'

import MultiProjectRepositories from 'src/modules/multi-project/repositories'
import MultiTaskRepositories from 'src/modules/multi-task/repositories'
import NetworkDiagramRepositories from 'src/modules/network-diagram/repositories'
import OntimeRepositories from 'src/modules/on-time/repositories'
import TrainingSessionRepositories from 'src/modules/training-session/repositories'
import AnimationRepositories from 'src/modules/animation/repositories'
import UserRepositories from 'src/modules/user/repositories'
import CompanyRepositories from 'src/modules/company/repositories'

import MeRepository from './commons/me.repository'
import MyCompanyRepositories from './commons/my-company.repository'

export default {
  getErrorCode,
  parseErrorMessage,
  me: MeRepository,
  myCompany: MyCompanyRepositories,
  multiProject: MultiProjectRepositories,
  multiTask: MultiTaskRepositories,
  networkDiagram: NetworkDiagramRepositories,
  ontime: OntimeRepositories,
  trainingSession: TrainingSessionRepositories,
  animation: AnimationRepositories,
  user: UserRepositories,
  company: CompanyRepositories,
}
